import { Google as GoogleIcon } from '@mui/icons-material';
import { ReactComponent as FacebookIcon } from '../../assets/fb-icon.svg';
import { ProviderLoginButton } from '../index';
import { isNextendActivated, isProviderActivated } from '../utils';
import style from './style.module.scss';

export const SocialLoginButtons = () => {
    if (!isNextendActivated()) {
        return null;
    }
    return (
        <div className={style.block}>
            {isProviderActivated('facebook') && (
                <ProviderLoginButton
                    text="Facebook"
                    icon={<FacebookIcon />}
                    background="#3d5c9a"
                    backgroundHover="#30497B"
                />
            )}

            {isProviderActivated('google') && (
                <ProviderLoginButton
                    text="Google"
                    icon={<GoogleIcon />}
                    background="#e14f45"
                    backgroundHover="#b43f37"
                />
            )}
        </div>
    );
};
